import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export interface ProfilePrivate {
  id: string;
  user_id: string;
  email: string;
  phone: string | null;
  phone_type: string | null;
  linkedin_url: string | null;
  parish: string | null;
  country: string | null;
  is_whatsapp: boolean | null;
  created_at: string;
  updated_at: string;
}

export function useProfilePrivate() {
  const { user } = useAuth();

  return useQuery({
    queryKey: ["profile_private", user?.id],
    queryFn: async () => {
      if (!user?.id) return null;
      
      const { data, error } = await supabase
        .from("profile_private")
        .select("*")
        .eq("user_id", user.id)
        .maybeSingle();

      if (error) throw error;
      return data as ProfilePrivate | null;
    },
    enabled: !!user?.id,
  });
}

export function useUpdateProfilePrivate() {
  const queryClient = useQueryClient();
  const { user } = useAuth();

  return useMutation({
    mutationFn: async (updates: Partial<ProfilePrivate>) => {
      if (!user?.id) throw new Error("Not authenticated");
      
      const { error } = await supabase
        .from("profile_private")
        .update(updates)
        .eq("user_id", user.id);

      if (error) throw error;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["profile_private"] });
    },
    onError: (error) => {
      toast.error("Failed to update contact info: " + error.message);
    },
  });
}
